import { styled } from "src/styles/theme";

export const PlainButton = styled("button", {
  margin: 0,
  padding: 0,
  border: 0,
  backgroundColor: "transparent",
  fontFamily: "$default",
  fontSize: "$base",
  userSelect: "none",
  cursor: "pointer",
});

export const Button = styled(PlainButton, {
  display: "inline-flex",
  justifyContent: "center",
  alignItems: "center",
  border: "1px solid transparent",
  borderRadius: "$2",
  fontSize: "$$fontSize",
  lineHeight: 1.2,
  transition: "all $duration1 ease",
  textDecoration: "none",

  "svg:first-child": {
    marginRight: "calc($$spaceInline / 2)",
  },

  "svg:last-child": {
    marginLeft: "calc($$spaceInline / 2)",
  },

  variants: {
    block: {
      true: {
        width: "100%",
        display: "block",
        textAlign: "center",
      },
    },

    color: {
      primary: {
        $$mainSolidColor: "$colors$primary9",
        $$mainSolidHoverColor: "$colors$primary10",
        $$onMainSolidColor: "$colors$onPrimary",

        $$mainColor: "$colors$primary8",
        $$mainHoverColor: "$colors$primary9",
        $$onMainColor: "$colors$onPrimary",

        $$altColor: "$colors$primary7",
        $$altHoverColor: "$colors$primary8",

        $$subtleColor: "$colors$primary2",
      },
      neutral: {
        $$mainSolidColor: "$colors$neutral11",
        $$mainSolidHoverColor: "$colors$neutral12",
        $$onMainSolidColor: "$colors$onNeutralDark",

        $$mainColor: "$colors$neutral8",
        $$mainHoverColor: "$colors$neutral9",
        $$onMainColor: "$colors$onNeutral",

        $$altColor: "$colors$neutral7",
        $$altHoverColor: "$colors$neutral8",

        $$subtleColor: "$colors$neutral2",
      },
      danger: {
        $$mainSolidColor: "$colors$danger9",
        $$mainSolidHoverColor: "$colors$danger10",
        $$onMainSolidColor: "$colors$onDanger",

        $$mainColor: "$colors$danger8",
        $$mainHoverColor: "$colors$danger9",
        $$onMainColor: "$colors$onDanger",

        $$altColor: "$colors$danger7",
        $$altHoverColor: "$colors$danger8",

        $$subtleColor: "$colors$danger2",
      },
    },

    size: {
      small: {
        $$spaceInline: "$space$2",
        $$spaceBlock: "$space$1",
        $$fontSize: "$fontSizes$sm",
      },
      normal: {
        $$spaceInline: "$space$3",
        $$spaceBlock: "$space$2",
        $$fontSize: "$fontSizes$base",
      },
      medium: {
        $$spaceInline: "$space$4",
        $$spaceBlock: "$space$2",
        $$fontSize: "$fontSizes$lg",
      },
      large: {
        $$spaceInline: "$space$6",
        $$spaceBlock: "$space$3",
        $$fontSize: "$fontSizes$lg",
      },
    },

    look: {
      text: {
        margin: "-$$spaceBlock -$$spaceInline",
        padding: "$$spaceBlock $$spaceInline",
        color: "$$mainSolidColor",

        "&:hover, &:focus": {
          backgroundColor: "$$subtleColor",
        },
      },

      plain: {
        padding: "$$spaceBlock $$spaceInline",
        backgroundColor: "$surface",
        color: "$$mainSolidColor",

        "&:hover, &:focus": {
          backgroundColor: "$$subtleColor",
        },
      },

      secondary: {
        padding: "$$spaceBlock $$spaceInline",
        boxShadow: "$2",
        borderColor: "$$altColor",
        backgroundColor: "$surface",
        color: "$$mainSolidColor",

        "&:hover, &:focus": {
          borderColor: "$$altHoverColor",
          backgroundColor: "$$subtleColor",
        },
      },

      primary: {
        padding: "$$spaceBlock $$spaceInline",
        backgroundColor: "$$mainSolidColor",
        fontWeight: "$medium",
        color: "$$onMainSolidColor",

        "&:hover, &:focus": {
          backgroundColor: "$$mainSolidHoverColor",
        },
      },
    },
  },
});

Button.defaultProps = {
  look: "secondary",
  size: "normal",
  color: "neutral",
};
